import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import { Modal } from 'react-bootstrap'
import { useGetPlayerCoinHistoryGanamos } from '../../../../../Hooks/Users/useGetPlayerCoinHistoryGanamos'
import { SingleTransfer } from '../../../../../Api/UserPanel/models'
import { formatUTCtoArgentinaTime } from '../../../../../../Utils/Utils'
import { BiLoaderCircle } from 'react-icons/bi'
interface Props {
    show: boolean
    onHide: () => void

    form: {
        name: string
    }
}


export const PlayerCoinHistoryGanamosModal = ({ show, onHide, form }: Props) => {
    const [otherHierarchies, setOtherHierarchies] = useState(false)
    const { playerCoinHistory, loading } = useGetPlayerCoinHistoryGanamos({ form, otherHierarchies: otherHierarchies })

    const getHistoryColor = (e: SingleTransfer) => {
        if (e?.operation === 1) { return 'red' }
        if (e?.operation === 0) { return 'green' }
        if (e?.operation === 2) { return 'orange' }
        return '';
    }

    const getHistoryLabel = (e: SingleTransfer) => {
        if (e?.operation === 1) { return 'Descarga' }
        if (e?.operation === 0) { return 'Carga' }
        if (e?.operation === 2) { return 'Bonificación' }
        return '';
    }


    const filteredHistory = playerCoinHistory?.data?.result?.transfers?.filter((item: any) => item?.to_user?.toLowerCase() === form.name.toLowerCase()) ?? []

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Historial de cargas/retiros</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {!loading &&
                    <div className="text-primary d-flex justify-content-between mb-3">
                        El usuario {form.name} tiene {playerCoinHistory?.data?.TotalAmount} fichas.
                        <div>
                            Rango: Últimos 30 días.
                        </div>
                    </div>
                }

                <div className='d-flex justify-content-center'>
                    {loading && <div className='d-flex justify-content-center my-5 gap-2 align-items-center'>
                        <div className='spin-animation d-flex align-items-center justify-content-center'>
                            <BiLoaderCircle size={20} />
                        </div>
                        <span>Cargando...</span>
                    </div>}


                    {!loading && <div>
                        {filteredHistory?.map((item: any) => (
                            <div key={item.id}>
                                <div style={{ color: getHistoryColor(item) }} className="d-flex gap-2">
                                    <span>{otherHierarchies && <span className='text-warning'>{item.from_user}: </span>}</span>
                                    <span>[{formatUTCtoArgentinaTime(item.created_at)}]</span>
                                    <span>{item.to_user}</span>
                                    <span>{item.amount}</span>
                                    <span>({getHistoryLabel(item)})</span>
                                </div>
                            </div>


                        ))}
                    </div>}

                </div>
            </Modal.Body>
            <Modal.Footer>

                <Button variant="primary" onClick={() => setOtherHierarchies(!otherHierarchies)}>
                    {otherHierarchies ? 'Buscar solo en mi jerarquía' : 'Buscar en otras jerarquías'}
                </Button>
                <Button variant="secondary" onClick={onHide}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>)
}
